import styled from '@emotion/styled';
import { Box, FormControlLabel } from '@mui/material';

export const NestedCheckboxGroupWrapper = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'first',
})<{ first?: boolean }>`
    padding: 0 0 0.5rem 0;
    ${(props) => !props.first && `padding-top: 0.5rem;`};
    width: 100%;
    border-bottom: 1px solid ${(props) => props.theme.input.border};
`;

export const NestedCheckboxFormControlLabel = styled(FormControlLabel)`
    margin: 0;
`;
